// Políticas de TTL (cache em memória) para o frontend.
// Ajuste aqui para controlar quanto tempo o dado pode ficar em cache.
// Observação: o cache é por sessão do SPA (reinicia ao dar F5).

export const CACHE_TTL = {
  // Dados bem estáveis (cadastros/configurações)
  SETTINGS_STABLE: 60 * 60 * 1000, // 60 min

  // Listas e dados que mudam, mas não a cada segundo
  PROCESSES: 10 * 60 * 1000, // 10 min
  DOCUMENT_TEMPLATES_LIST: 10 * 60 * 1000, // 10 min
  DOCUMENT_TEMPLATE_GET: 30 * 60 * 1000, // 30 min

  // Painéis/resumos
  DASHBOARD: 3 * 60 * 1000, // 3 min
  FINANCE: 2 * 60 * 1000, // 2 min
  FINANCE_SUMMARY: 2 * 60 * 1000, // 2 min

  // Itens mais dinâmicos
  NOTIFICATIONS_LIST: 60 * 1000, // 60s
  NOTIFICATIONS_COUNT: 30 * 1000, // 30s
  TASKS_LIST: 60 * 1000, // 60s
  TASKS_SEARCH: 60 * 1000, // 60s
  TASKS_STATS: 60 * 1000, // 60s

  // Agenda costuma ter alterações, mas dá pra segurar um pouco
  SCHEDULE: 2 * 60 * 1000, // 2 min

  // Busca: não vale cache muito longo
  SEARCH: 2 * 60 * 1000, // 2 min
};
